import { Outlet, useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/hooks/use-auth'
import { TenantProvider } from '@/hooks/use-tenant'
import { Sidebar } from './sidebar'
import { Header } from './header'
import { useEffect } from 'react'

export function AppShell() {
  const { isAuthenticated, isLoading, user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate({ to: '/login' })
    }
  }, [isLoading, isAuthenticated, navigate])

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center" style={{ backgroundColor: 'var(--color-background)' }}>
        <div className="flex flex-col items-center gap-4">
          <div
            className="h-10 w-10 animate-spin rounded-full border-4 border-t-transparent"
            style={{ borderColor: 'var(--color-brand-secondary)', borderTopColor: 'transparent' }}
          />
          <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
            Cargando...
          </p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) return null

  return (
    <TenantProvider>
      <div className="flex h-screen" style={{ backgroundColor: 'var(--color-background)' }}>
        <Sidebar userRole={user?.role} />
        <div className="flex flex-1 flex-col" style={{ marginLeft: 'var(--sidebar-width)' }}>
          <Header />
          <main className="flex-1 overflow-y-auto p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </TenantProvider>
  )
}
